import React from 'react';

import DepartmentFilterColumn from "../../shared/component/dataTable/columns/DepartmentFilterColumn.json";

import {Button} from "reactstrap";

import Translate from "../../shared/language/Translate";

import DataTableAll from "../../shared/component/dataTable/DataTableAll";

import DepartmentService from "../../shared/service/DepartmentService";

import '../../shared/styles/SettingsPage.css';



export default class DepartmentFilter extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            departmentList: []

        };

        this.departmentService = new DepartmentService();

    }



    componentDidMount() {

        this.departmentService.findAll().then(response => this.setState({

            departmentList: response

        }));

        this.refreshDataTable();

    }



    render() {

        return (

            <div className="settings-page settings-page--dialog settings-page--lookup-picker">

                <h2 className="settings-page__section-title">Department List</h2>

                <div className="settings-page__table-wrap settings-page__table-wrap--lookup-dialog">

                    <DataTableAll ref={(elem) => this.refDataTable = elem}

                                  fields={DepartmentFilterColumn.fields}

                                  objectName={DepartmentFilterColumn.name}

                                  data={this.state.departmentList}

                                  rows={10}

                                  closeFilterDialog={this.props.closeDisplayDialog}

                                  onDataSelect={this.onDataSelect}

                                  selectionMode="single"

                                  loading={this.state.loading}/>

                </div>

                <div className="settings-page__actions settings-page__actions--dialog-footer">

                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close"

                            onClick={() => this.props.closeDisplayDialog()}>

                        <Translate contentKey="entity.action.cancel">Close</Translate>

                    </Button>

                </div>

            </div>

        );

    }



    refreshDataTable = () => {

        this.refDataTable.refresh();

    }



    onDataSelect = (data) => {

        this.props.onDataSelect(data);

    }

}

